import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { LanguageService } from 'src/app/services/language.service';

@Pipe({
  name: 'plusMinPrice',
})
export class PlusMinPricePipe implements PipeTransform {
  currenyPipe: CurrencyPipe;

  constructor(private languageService: LanguageService) {
    this.currenyPipe = new CurrencyPipe(this.languageService.currentLanguage);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: any, ...args: any[]): any {
    const language = this.languageService.currentLanguage;
    if (value === false) {
      return '?';
    }
    const styledValue = this.currenyPipe.transform(value, 'EUR', 'symbol', '1.2-2', language);
    if (value > 0) {
      if (language === 'nl') {
        return this.insertIntoString(styledValue, 2, '+');
      }
      return '+' + styledValue;
    }
    return styledValue;
  }

  insertIntoString(string: string, index: number, value: string) {
    if (index > 0) {
      return string.substring(0, index) + value + string.substring(index, string.length);
    }
    return value + this;
  }
}
